import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import BgImg from "../../../images/case-studies/kinekt-new/results-achive-back.webp";

function Resultskinekt() {
  return (
    <section className="results-kinekt p-100">
      <Container>
        <div
          className="result-achieve-box"
          style={{ backgroundImage: `url(${BgImg})` }}
        >
          <Row>
            <Col
              xs={12}
              md={12}
              lg={12}
              xl={12}
              xxl={12}
              className="text-center mb-4 mb-md-5"
            >
              <h2 className="head-h2-kinekt">
                Results & <span style={{ color: "#20A2BE" }}>Achievements</span>
              </h2>
            </Col>
          </Row>
          <Row>
            <Col
              xs={12}
              md={12}
              lg={10}
              xl={10}
              xxl={10}
              className="m-auto text-center"
            >
              <div className="result-main">
                <div className="results-item">
                  <div className="results-content">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="208"
                      height="209"
                      fill="none"
                      viewBox="0 0 208 209"
                    >
                      <path
                        fill="#20A2BE"
                        d="M75.253 92.855q-.52-2.405-1.82-3.575-1.3-1.235-3.705-1.235-3.705 0-5.33 3.25-1.625 3.185-1.69 10.14 1.43-2.275 4.095-3.575 2.73-1.3 5.98-1.3 6.37 0 10.205 4.03 3.9 4.03 3.9 11.245 0 4.745-1.95 8.32-1.885 3.575-5.59 5.59-3.64 2.015-8.645 2.015-10.01 0-13.91-6.24-3.9-6.305-3.9-18.07 0-12.35 4.095-18.33 4.16-6.045 13.26-6.045 4.875 0 8.19 1.95 3.38 1.885 5.07 5.005 1.755 3.12 2.08 6.825zm-5.135 12.48q-2.795 0-4.68 1.69-1.82 1.624-1.82 4.68 0 3.12 1.69 4.875 1.755 1.755 4.94 1.755 2.86 0 4.485-1.69 1.69-1.755 1.69-4.745 0-3.055-1.625-4.81t-4.68-1.755m19.157-2.21q0-11.18 4.29-17.615 4.354-6.435 13.975-6.435t13.91 6.435q4.355 6.435 4.355 17.615 0 11.31-4.355 17.745-4.29 6.435-13.91 6.435t-13.975-6.435q-4.29-6.435-4.29-17.745m25.61 0q0-6.565-1.43-10.075-1.43-3.575-5.915-3.575t-5.915 3.575q-1.43 3.51-1.43 10.075 0 4.42.52 7.345.52 2.86 2.08 4.68 1.625 1.755 4.745 1.755t4.68-1.755q1.624-1.82 2.145-4.68.52-2.925.52-7.345m11.331.351q0-3.565 2.024-5.5 2.068-1.935 5.324-1.936t5.28 1.936q2.024 1.935 2.024 5.5t-2.024 5.5q-2.024 1.936-5.28 1.936t-5.324-1.936q-2.024-1.936-2.024-5.5m29.876-6.952-16.94 30.976h-7.26l16.94-30.976zm-22.572 3.916q-2.112 0-2.112 3.036 0 2.992 2.112 2.992 1.013 0 1.584-.748.572-.749.572-2.244 0-3.036-2.156-3.036m13.64 20.108q0-3.564 2.024-5.5t5.28-1.936q3.257 0 5.28 1.936t2.024 5.5q0 3.564-2.024 5.5t-5.28 1.936q-3.257 0-5.28-1.936t-2.024-5.5m7.26-3.036q-1.013 0-1.584.748-.528.748-.528 2.288 0 2.992 2.112 2.992 1.013 0 1.584-.748.572-.749.572-2.244t-.572-2.244q-.571-.792-1.584-.792"
                      ></path>
                      <mask id="path-2-inside-1_7035_5671" fill="#fff">
                        <path d="M56.106 196.839a104.005 104.005 0 0 0 120.266-17.627 104 104 0 0 0 21.406-119.65A103.995 103.995 0 0 0 91.085 1.327a104 104 0 0 0-89.052 82.73l16.414 3.295a87.26 87.26 0 1 1 45.369 94.626z"></path>
                      </mask>
                      <path
                        fill="#D9D9D9"
                        stroke="#20A2BE"
                        strokeLinejoin="round"
                        strokeWidth="28"
                        d="M56.106 196.839a104.005 104.005 0 0 0 120.266-17.627 104 104 0 0 0 21.406-119.65A103.995 103.995 0 0 0 91.085 1.327a104 104 0 0 0-89.052 82.73l16.414 3.295a87.26 87.26 0 1 1 45.369 94.626z"
                        mask="url(#path-2-inside-1_7035_5671)"
                      ></path>
                    </svg>
                    <h5>Reduced patient response time</h5>
                  </div>
                </div>
                <div className="results-item">
                  <div className="results-content">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="208"
                      height="209"
                      fill="none"
                      viewBox="0 0 208 209"
                    >
                      <path
                        fill="#20A2BE"
                        d="M50.81 119.05v-8.97L71.35 80.7h12.415v28.73h5.33v9.62h-5.33v8.45H72.65v-8.45zm22.62-26.13-10.92 16.51h10.92zm50.619-3.185h-20.28v8.97q1.3-1.43 3.64-2.34t5.07-.91q4.875 0 8.06 2.21 3.25 2.21 4.745 5.72t1.495 7.605q0 7.605-4.29 12.09-4.29 4.42-12.09 4.42-5.2 0-9.035-1.755-3.834-1.82-5.915-5.005t-2.275-7.345h10.855a6 6 0 0 0 1.885 3.38q1.495 1.3 4.095 1.3 3.056 0 4.55-1.95 1.495-1.95 1.495-5.2 0-3.185-1.56-4.875t-4.55-1.69q-2.21 0-3.64 1.105-1.43 1.04-1.885 2.795H93.694V79.985h30.355zm3.405 13.741q0-3.565 2.024-5.5 2.067-1.935 5.324-1.936 3.255 0 5.28 1.936 2.024 1.935 2.024 5.5t-2.024 5.5q-2.025 1.936-5.28 1.936-3.257 0-5.324-1.936-2.025-1.936-2.024-5.5m29.876-6.952L140.39 127.5h-7.26l16.94-30.976zm-22.572 3.916q-2.112 0-2.112 3.036 0 2.992 2.112 2.992 1.011 0 1.584-.748.572-.749.572-2.244 0-3.036-2.156-3.036m13.64 20.108q0-3.564 2.024-5.5t5.28-1.936q3.255 0 5.28 1.936 2.024 1.936 2.024 5.5t-2.024 5.5q-2.025 1.936-5.28 1.936-3.257 0-5.28-1.936-2.025-1.936-2.024-5.5m7.26-3.036q-1.013 0-1.584.748-.528.748-.528 2.288 0 2.992 2.112 2.992 1.011 0 1.584-.748.572-.749.572-2.244t-.572-2.244q-.573-.792-1.584-.792"
                      ></path>
                      <mask id="path-2-inside-1_7049_11412" fill="#fff">
                        <path d="M129.245 205.413a104.01 104.01 0 0 0 76.17-77.845 104 104 0 0 0-35.05-103.117A104 104 0 0 0 62.535 9.147 104 104 0 0 0 .178 98.441l16.712.979a87.26 87.26 0 1 1 108.291 89.753z"></path>
                      </mask>
                      <path
                        fill="#D9D9D9"
                        stroke="#20A2BE"
                        strokeLinejoin="round"
                        strokeWidth="28"
                        d="M129.245 205.413a104.01 104.01 0 0 0 76.17-77.845 104 104 0 0 0-35.05-103.117A104 104 0 0 0 62.535 9.147 104 104 0 0 0 .178 98.441l16.712.979a87.26 87.26 0 1 1 108.291 89.753z"
                        mask="url(#path-2-inside-1_7049_11412)"
                      ></path>
                    </svg>
                    <h5>User engagement increased</h5>
                  </div>
                </div>
                <div className="results-item">
                  <div className="results-content">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="208"
                      height="209"
                      fill="none"
                      viewBox="0 0 208 209"
                    >
                      <path
                        fill="#20A2BE"
                        d="M53.257 93.44q.26-6.956 4.55-10.725 4.29-3.77 11.635-3.77 4.875 0 8.32 1.69 3.51 1.69 5.265 4.615 1.82 2.925 1.82 6.565 0 4.29-2.145 7.02-2.145 2.665-5.005 3.64v.26q3.705 1.234 5.85 4.095t2.145 7.345q0 4.03-1.885 7.15-1.82 3.055-5.395 4.81-3.51 1.755-8.385 1.755-7.8 0-12.48-3.835-4.615-3.835-4.875-11.57h10.79q.065 2.86 1.625 4.55 1.56 1.625 4.55 1.625 2.535 0 3.9-1.43 1.43-1.495 1.43-3.9 0-3.12-2.015-4.485-1.95-1.43-6.305-1.43h-2.08V98.38h2.08q3.315 0 5.33-1.105 2.08-1.17 2.08-4.095 0-2.34-1.3-3.64t-3.575-1.3q-2.47 0-3.705 1.495-1.17 1.496-1.365 3.705zm68.475-3.705h-20.28v8.97q1.3-1.43 3.64-2.34t5.07-.91q4.875 0 8.06 2.21 3.25 2.21 4.745 5.72t1.495 7.605q0 7.605-4.29 12.09-4.29 4.42-12.09 4.42-5.2 0-9.034-1.755-3.836-1.82-5.916-5.005t-2.275-7.345h10.855a6 6 0 0 0 1.885 3.38q1.495 1.3 4.095 1.3 3.056 0 4.55-1.95 1.495-1.95 1.495-5.2 0-3.185-1.56-4.875t-4.55-1.69q-2.21 0-3.64 1.105-1.43 1.04-1.885 2.795H91.377V79.985h30.355zm3.405 13.741q0-3.565 2.024-5.5 2.068-1.935 5.324-1.936 3.257 0 5.28 1.936t2.024 5.5q0 3.564-2.024 5.5t-5.28 1.936-5.324-1.936q-2.024-1.936-2.024-5.5m29.876-6.952-16.94 30.976h-7.26l16.94-30.976zm-22.572 3.916q-2.112 0-2.112 3.036 0 2.992 2.112 2.992 1.013 0 1.584-.748.572-.749.572-2.244 0-3.036-2.156-3.036m13.64 20.108q0-3.564 2.024-5.5t5.28-1.936q3.257 0 5.28 1.936t2.024 5.5q0 3.564-2.024 5.5t-5.28 1.936q-3.257 0-5.28-1.936t-2.024-5.5m7.26-3.036q-1.013 0-1.584.748-.528.748-.528 2.288 0 2.992 2.112 2.992 1.013 0 1.584-.748.572-.749.572-2.244t-.572-2.244q-.571-.792-1.584-.792"
                      ></path>
                      <mask id="path-2-inside-1_7049_11418" fill="#fff">
                        <path d="M129.245 205.413a104.01 104.01 0 0 0 76.17-77.845 104 104 0 0 0-35.05-103.117A104 104 0 0 0 62.535 9.147 104 104 0 0 0 .178 98.441l16.712.979a87.26 87.26 0 1 1 108.291 89.753z"></path>
                      </mask>
                      <path
                        fill="#D9D9D9"
                        stroke="#20A2BE"
                        strokeLinejoin="round"
                        strokeWidth="28"
                        d="M129.245 205.413a104.01 104.01 0 0 0 76.17-77.845 104 104 0 0 0-35.05-103.117A104 104 0 0 0 62.535 9.147 104 104 0 0 0 .178 98.441l16.712.979a87.26 87.26 0 1 1 108.291 89.753z"
                        mask="url(#path-2-inside-1_7049_11418)"
                      ></path>
                    </svg>
                    <h5>Improved social media sentiment accuracy</h5>
                  </div>
                </div>
                <div className="results-item">
                  <div className="results-content">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="208"
                      height="209"
                      fill="none"
                      viewBox="0 0 208 209"
                    >
                      <path
                        fill="#20A2BE"
                        d="M40.84 90.385V80.05h18.006v47.45h-11.57V90.385zm21.71 12.74q0-11.18 4.29-17.615 4.355-6.435 13.974-6.435t13.91 6.435q4.356 6.435 4.355 17.615 0 11.31-4.355 17.745-4.29 6.435-13.91 6.435T66.84 120.87q-4.29-6.435-4.29-17.745m25.61 0q0-6.565-1.43-10.075-1.431-3.575-5.916-3.575-4.484 0-5.915 3.575-1.43 3.51-1.43 10.075 0 4.42.52 7.345.52 2.86 2.08 4.68 1.626 1.755 4.745 1.755t4.68-1.755q1.626-1.82 2.145-4.68.52-2.925.52-7.345m12.892 0q0-11.18 4.29-17.615 4.354-6.435 13.975-6.435t13.91 6.435q4.355 6.435 4.355 17.615 0 11.31-4.355 17.745-4.29 6.435-13.91 6.435t-13.975-6.435q-4.29-6.435-4.29-17.745m25.61 0q0-6.565-1.43-10.075-1.43-3.575-5.915-3.575t-5.915 3.575q-1.43 3.51-1.43 10.075 0 4.42.52 7.345.52 2.86 2.08 4.68 1.625 1.755 4.745 1.755t4.68-1.755q1.624-1.82 2.145-4.68.52-2.925.52-7.345m11.331.351q0-3.565 2.024-5.5 2.068-1.935 5.324-1.936 3.257 0 5.28 1.936t2.024 5.5q0 3.564-2.024 5.5t-5.28 1.936-5.324-1.936q-2.024-1.936-2.024-5.5m29.876-6.952-16.94 30.976h-7.26l16.94-30.976zm-22.572 3.916q-2.112 0-2.112 3.036 0 2.992 2.112 2.992 1.013 0 1.584-.748.572-.749.572-2.244 0-3.036-2.156-3.036m13.64 20.108q0-3.564 2.024-5.5t5.28-1.936 5.28 1.936 2.024 5.5-2.024 5.5q-2.023 1.936-5.28 1.936-3.256 0-5.28-1.936t-2.024-5.5m7.26-3.036q-1.013 0-1.584.748-.528.748-.528 2.288 0 2.992 2.112 2.992 1.013 0 1.584-.748.572-.749.572-2.244t-.572-2.244q-.571-.792-1.584-.792"
                      ></path>
                      <mask id="path-2-inside-1_7049_11424" fill="#fff">
                        <path d="M0 104.523c0 57.438 46.562 104 104 104s104-46.562 104-104c0-57.437-46.562-104-104-104S0 47.086 0 104.523m191.259 0c0 48.192-39.067 87.26-87.259 87.26s-87.26-39.068-87.26-87.26c0-48.191 39.068-87.259 87.26-87.259s87.259 39.067 87.259 87.259"></path>
                      </mask>
                      <path
                        fill="#D9D9D9"
                        stroke="#20A2BE"
                        strokeLinejoin="round"
                        strokeWidth="28"
                        d="M0 104.523c0 57.438 46.562 104 104 104s104-46.562 104-104c0-57.437-46.562-104-104-104S0 47.086 0 104.523Zm191.259 0c0 48.192-39.067 87.26-87.259 87.26s-87.26-39.068-87.26-87.26c0-48.191 39.068-87.259 87.26-87.259s87.259 39.067 87.259 87.259Z"
                        mask="url(#path-2-inside-1_7049_11424)"
                      ></path>
                    </svg>
                    <h5>Automation in feedback collection & categorization</h5>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </Container>
    </section>
  );
}

export default Resultskinekt;
